// Archived projects stay loaded everywhere (so existing entries still
// resolve their name and colour) but drop out of every "pick a project to
// log time" control. keepId keeps one archived project in the list - the one
// an existing entry already sits on - so editing that entry still shows it.
const activeProjects = (projects, keepId) => projects.filter((p) => !p.archived || p.id === keepId);

export default activeProjects;
